import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextHeaders = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M10.8837 6.53211C10.7104 6.20475 10.3704 6 9.99996 6C9.62955 6 9.28948 6.20475 9.11617 6.53211L0.116168 23.5321C-0.142239 24.0202 0.0439656 24.6254 0.532068 24.8838C1.02017 25.1422 1.62534 24.956 1.88374 24.4679L4.2491 20H15.7508L18.1162 24.4679C18.3746 24.956 18.9797 25.1422 19.4678 24.8838C19.9559 24.6254 20.1422 24.0202 19.8837 23.5321L10.8837 6.53211ZM14.692 18L9.99996 9.13727L5.30792 18H14.692Z"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M26 16.3625C27.0965 16.3625 28.1472 16.6912 29 17.2631V16.3625C29 15.0988 27.7901 13.8625 26 13.8625H25.9888C25.1338 13.8529 24.3093 14.1792 23.6926 14.7714C23.2942 15.1539 22.6612 15.141 22.2787 14.7426C21.8962 14.3442 21.909 13.7112 22.3074 13.3287C23.3009 12.3748 24.6286 11.8485 26.0056 11.8625C28.6382 11.8652 31 13.7531 31 16.3625V24C31 24.5523 30.5523 25 30 25C29.5914 25 29.24 24.7549 29.0848 24.4037C28.2174 25.0115 27.1331 25.3625 26 25.3625C23.3682 25.3625 21 23.469 21 20.8625C21 18.256 23.3682 16.3625 26 16.3625ZM23 20.8625C23 19.603 24.2135 18.3625 26 18.3625C27.7865 18.3625 29 19.603 29 20.8625C29 22.1219 27.7865 23.3625 26 23.3625C24.2135 23.3625 23 22.1219 23 20.8625Z"
	})]
});
export default SvgTextHeaders;
